import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataType } from 'src/app/global/forms/categoria-plano-conta-form/categoria-plano-conta-form.component';

@Component({
  selector: 'app-pesquisa-mapa-form',
  templateUrl: './pesquisa-mapa-form.component.html',
  styleUrls: ['./pesquisa-mapa-form.component.css']
})
export class PesquisaMapaFormComponent implements OnInit {

  pesquisaForm!: FormGroup;

  constructor(public dialogRef: MatDialogRef<PesquisaMapaFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataType,
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.pesquisaForm = this.fb.group({
      numeroPesquisaMapa: ['', Validators.required],
      dataCadastro: ['', Validators.required],
      usuario: ['', Validators.required],
      nomePesquisa: ['', Validators.required],
      estado: ['', Validators.required]
    });
  }

  onConfirm() {
      this.dialogRef.close(this.pesquisaForm.value);
}
onCancel(): void {
this.dialogRef.close();
}
}
